// Domain 04 check helpers — read live (cloned) state; never mutate the lab.
import { clone } from '../../engine/net/model.js';
import { tunnelState } from '../../engine/net/wan.js';
import { qosAnalyze } from '../../engine/net/qos.js';
import { roundTrip, ifStatus } from '../../engine/net/sim.js';
import { rib } from '../d03/helpers.js';
export * from '../d03/helpers.js';

export const tun = (rt, id, ifc = 'Tunnel0') => tunnelState(clone(rt.net))[`${id}|${ifc}`] || null;
export const tunnelUp = (rt, id, ifc = 'Tunnel0') => tun(rt, id, ifc)?.protocol === 'up' && !!tun(rt, id, ifc)?.peer;
export const flowQ = (rt, f) => qosAnalyze(clone(rt.net)).flows[f] || null;
export const ifQ = (rt, id, ifc) => qosAnalyze(clone(rt.net)).ifs[`${id}|${ifc}`] || null;
export const lineUp = (rt, id, ifc) => ifStatus(rt.net, id, ifc).protocol === 'up';
/** TCP service reachable end to end (users' view). */
export const svc = (rt, src, dst, port) => roundTrip(clone(rt.net), src, dst, { proto: 'tcp', port }).ok;
/** Installed route check: prefix via a given next hop (or exit interface). */
export const routeIs = (rt, id, net, prefix, via) => rib(rt, id).some((r) => r.net === net && r.prefix === prefix && (r.nh === via || r.ifc === via));
/** Same check on a copy of the lab with a change applied first (failover tests). */
export function withChange(rt, change, fn) {
  const c = { net: clone(rt.net) };
  change(c.net);
  return fn(c);
}
export const cfgRoute = (rt, id, net, nh, ad = 1) => rt.net.devices[id].routes.some((r) => r.net === net && (r.nh === nh || r.ifc === nh) && (r.ad || 1) === ad);
/** IOS show command evidence (any of the given keys) with optional output regex. */
export const ios = (device, keys, re) => (ev) => ev.type === 'cmd' && ev.device === device && (Array.isArray(keys) ? keys : [keys]).some((k) => (k instanceof RegExp ? k.test(ev.key) : ev.key === k)) && ev.ok !== false && (!re || re.test(ev.output));
